// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__198AL","colMin":"styles_colMin__1h7NS","colCheckbox":"styles_colCheckbox__33NX9"};